import React from 'react'
import numbro from 'numbro'
import { formatDistance } from 'supporticon/utils/fitness'
import Metric from '../Metric'

const Elevation = ({
  amountColor,
  format,
  fundraisingPage,
  icon,
  iconColor,
  iconSize,
  label,
  labelColor,
  offset,
  multiplier,
  numberStyle,
  uom
}) => {
  const amount = multiplier
    ? numbro(fundraisingPage.fitnessElevationTotal * (multiplier || 1) + (offset || 0)).format(format || '0,0')
    : formatDistance(fundraisingPage.fitnessElevationTotal + (offset || 0), uom === 'mi')

  return (
    <Metric
      amount={amount}
      amountColor={amountColor}
      icon={icon}
      iconSize={iconSize || 'small'}
      labelColor={iconColor}
      numberStyle={numberStyle}
      label={label}
    />
  )
}

export default Elevation
